import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import {
    LuMail,
    LuMessageCircle
} from "react-icons/lu";
import { FaXTwitter, FaGithub, FaLinkedin } from "react-icons/fa6";

function Footer() {
    const { t, lang } = useLanguage();

    return (
        <footer className="footer">
            <div className="footer-content">
                <div className="footer-grid">
                    {/* Brand Section */}
                    <div className="footer-brand">
                        <div className="footer-logo">
                            <div className="logo-icon">G</div>
                            <span>Getiri Hesaplama</span>
                        </div>
                        <p className="footer-tagline">
                            {lang === 'tr'
                                ? 'Yatirimlarinizi akillica yonetin, geleceginizi guvence altina alin.'
                                : 'Manage your investments wisely, secure your future.'}
                        </p>
                        <div className="footer-social">
                            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                                <FaXTwitter />
                            </a>
                            <a href="https://github.com" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
                                <FaGithub />
                            </a>
                            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                                <FaLinkedin />
                            </a>
                        </div>
                    </div>

                    {/* Product Links */}
                    <div className="footer-section">
                        <h4>{lang === 'tr' ? 'Urun' : 'Product'}</h4>
                        <ul>
                            <li><Link to="/">{t('nav.home')}</Link></li>
                            <li><Link to="/pricing">{t('nav.pricing')}</Link></li>
                            <li><Link to="/faq">{t('nav.faq')}</Link></li>
                        </ul>
                    </div>

                    {/* Support Links */}
                    <div className="footer-section">
                        <h4>{t('nav.support')}</h4>
                        <ul>
                            <li><Link to="/support">{lang === 'tr' ? 'Iletisim' : 'Contact'}</Link></li>
                            <li><Link to="/faq">{lang === 'tr' ? 'SSS' : 'FAQ'}</Link></li>
                        </ul>
                    </div>

                    {/* Legal Links */}
                    <div className="footer-section">
                        <h4>{lang === 'tr' ? 'Yasal' : 'Legal'}</h4>
                        <ul>
                            <li><Link to="/terms">{t('legal.terms')}</Link></li>
                            <li><Link to="/privacy">{t('legal.privacy')}</Link></li>
                        </ul>
                    </div>

                    {/* Contact */}
                    <div className="footer-section">
                        <h4>{lang === 'tr' ? 'Iletisim' : 'Contact'}</h4>
                        <ul className="footer-contact">
                            <li>
                                <LuMail />
                                <a href="mailto:info@getirihesaplama.com">info@getirihesaplama.com</a>
                            </li>
                            <li>
                                <LuMessageCircle />
                                <Link to="/support">{lang === 'tr' ? 'Canli Destek' : 'Live Chat'}</Link>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="footer-bottom">
                    <p className="footer-copyright">
                        &copy; {new Date().getFullYear()} Getiri Hesaplama. {t('footer.rights')}.
                    </p>
                    <div className="footer-bottom-links">
                        <Link to="/terms">{t('legal.terms')}</Link>
                        <span className="separator">|</span>
                        <Link to="/privacy">{t('legal.privacy')}</Link>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
